import firebase from "firebase/compat/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
  collection,
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import "firebase/compat/auth";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPID,
};

const app = firebase.initializeApp(firebaseConfig);

// ── Compuerta del flip (Topología A, go-live gtr-2026) ────────────────────────
// VUE_APP_FIRESTORE_PROD_DATABASE_ID selecciona la BD Firestore NOMBRADA a la
// que apunta TODO el acceso a datos del front (p.ej. "gtr-2026").
// Vacío/ausente ⇒ (default): el comportamiento de hoy, de dev y del emulador.
// EL FLIP = poner ese env var en el .env de producción y rebuild+deploy.
// No existe flip parcial: `firestore` es el ÚNICO handle de datos del front
// (el handle compat `fbfs` fue eliminado — compat no soporta BD nombrada y tras
// el flip leería (default) EN SILENCIO).
const prodDbId = process.env.VUE_APP_FIRESTORE_PROD_DATABASE_ID || "";
const firestore = prodDbId ? getFirestore(app, prodDbId) : getFirestore(app);
// Sin pines a (default): TAMBIÉN el kill-switch del freeze
// (`systemConfiguration/frontend.offline`) se lee de la BD viva (decisión de
// Hector, Topología A) — ver el listener en SystemConfigStore. (default) queda
// como copia dormida solo para rollback; nadie la lee post-flip.

// utils
const authCompat = firebase.auth();
const auth = getAuth(app);
const func = firebase.functions();
const functions = getFunctions(app);
const storageCompat = firebase.storage();
const storage = getStorage();

let reCaptchaSiteKey = process.env.VUE_APP_ReCaptchaV3Provider || "";
if (location.hostname === "localhost") {
  // Token fijo (ya registrado en Firebase Console > App Check > debug tokens),
  // no `true` — con `true` el SDK genera uno nuevo cada vez que el storage del
  // navegador se limpia, y ese token nunca está registrado -> App Check rechaza todo.
  self.FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.VUE_APP_ReCaptcha_Debug_Token;
  reCaptchaSiteKey = process.env.VUE_APP_ReCaptchaV3Provider || "";

  const firebaseHost = process.env.VUE_APP_FIREBASE_HOST || "localhost";

  // Dev/emulador corre SIEMPRE con env vacío ⇒ `firestore` ES la instancia
  // (default) y esto conserva el comportamiento de hoy contra el emulador.
  connectFirestoreEmulator(firestore, firebaseHost, 8090);
  authCompat.useEmulator(`http://${firebaseHost}:9099`);
  connectAuthEmulator(auth, `http://${firebaseHost}:9099`);
  func.useEmulator(firebaseHost, 5001);
  connectFunctionsEmulator(functions, firebaseHost, 5001);

  connectStorageEmulator(storage, "localhost", 9199);
}
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(reCaptchaSiteKey),
  isTokenAutoRefreshEnabled: true,
});

// collection references (modular) — siguen el flip vía `firestore`.
const ranksCollection = collection(firestore, "ranksConfiguration");
const usersCollection = collection(firestore, "users");
// Cutover (#559): binaryTree replaced the legacy binary-tree. The former
// `binaryTreeCollection` export had no consumers (§19) and was dropped in the
// compat→modular migration (#598) rather than recreated onto the modular SDK.

// export utils/refs
export {
  auth,
  firestore,
  functions,
  authCompat as authCompat,
  func,
  storageCompat,
  storage,
  ranksCollection,
  usersCollection,
};
